import { LogEvent, TrackingEvent } from '../../model/monitoring'
import {
  VerificationError,
  VerificationErrorCode,
  VerificationFlowContext,
  VerificationMethod,
  VerifyRegistrationSMSAuthorizationMessage,
} from '@afterpaytouch/registration'
import { FetchVerificationErrorResponse } from '@afterpaytouch/event-verify'
import { registrationErrors } from '../../state'
import { ErrorCode } from '@afterpaytouch/portal-api'

interface HandleVerificationErrorArgs {
  logEvent: LogEvent
  e: VerificationError | Error
  onError: (code: VerificationErrorCode) => void
  onTerminalError: (code?: VerificationErrorCode) => void
}

export const handleVerificationError = ({ logEvent, e, onError, onTerminalError }: HandleVerificationErrorArgs): void => {
  logEvent(TrackingEvent.VIEWED_VERIFY_ERROR, { error: e.message })
  if (!VerificationError.is(e)) {
    return
  }

  if (e.isFatal) {
    onTerminalError(e.code)
  } else if (e.isSignUpError) {
    onError(e.code)
  }
}

export const getErrorMessage = (e: VerificationError): string => {
  const { code: errorCode } = e
  switch (errorCode) {
    case VerificationErrorCode.CodeInvalid:
      return 'verify:error:incorrectResetCode'
    case VerificationErrorCode.CodeExpired:
      return 'verify:error:expiredCode'
  }
  return 'verify:error:default'
}

export const convertAuthzErrorEventToVerificationError = (e: FetchVerificationErrorResponse): VerificationError => {
  if (e.message === VerifyRegistrationSMSAuthorizationMessage.INVALID_REQUEST_PAYLOAD) {
    throw new Error()
  }
  return new VerificationError(registrationErrors[e.message?.toLowerCase() ?? ErrorCode.Error])
}

export const getErrorToastTransKey = (e: VerificationError, context: VerificationFlowContext, method: VerificationMethod): string => {
  if (context === VerificationFlowContext.Efa) {
    return e.code === VerificationErrorCode.ErrorSendingCode ? 'verify:error:codeSentFailEFA' : 'verify:error:timeout'
  } else {
    return `verify:error:codeSentFail_${method}`
  }
}
